<template>
  <div class="aside" :class="{ 'is-collapse': sidebarCollapsed }">
    <div class="aside-logo-content" @click="goHome">
      <div class="aside-logo-mark">
        <img :src="logo" class="logo-img" alt="" />
      </div>
      <span class="aside-logo-text">{{ $t("brand.name") }}</span>
    </div>
    <div class="el-menu-content">
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical-demo"
        :default-openeds="openedMenus"
        :collapse="sidebarCollapsed"
        :collapse-transition="false"
        background-color="#ffffff"
        text-color="#303133"
        active-text-color="#409EFF"
        unique-opened
        router
      >
        <template v-for="m in menus">
          <el-submenu
            :index="m.url"
            :key="m.url"
            v-if="m.children && m.children.length > 0"
          >
            <template slot="title">
              <i :class="menuIconClass(m.url)" />
              <span class="menu-label">{{ $menuLabel(m.url, m.menu_name) }}</span>
            </template>
            <el-menu-item :index="cM.url" :key="cM.url" v-for="cM in m.children">
              <span slot="title">{{ $menuLabel(cM.url, cM.menu_name) }}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item :index="m.url" :key="m.url" v-else>
            <i :class="menuIconClass(m.url)" />
            <span slot="title" class="menu-label">{{ $menuLabel(m.url, m.menu_name) }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import routes from "@/router/routes";
import { flattenRoute } from "@/utils/menu";
import { menusIconConfig } from "@/constants/menus";
import { mapState } from "vuex";
import { isNeedChangePassword } from "@/utils/account";
export default {
  data() {
    return {
      activeMenu: undefined,
      openedMenus: [],
      menusIconConfig,
      logo: require("../../assets/logo-main-new.png"),
    };
  },
  created() {
    this.getUserAuthorizedMenus();
  },
  mounted() {
    this.initActiveMenu();
  },
  computed: {
    ...mapState(["authorizedMenus", "loginAccountInfo", "sidebarCollapsed"]),
    menus() {
      return this.authorizedMenus || [];
    },
  },
  watch: {
    sidebarCollapsed(val) {
      if (val) {
        this.openedMenus = [];
      } else {
        this.openedMenus = this.getOpenedKeys();
      }
    },
    $route(v) {
      if (!this.sidebarCollapsed) {
        this.openedMenus = this.getOpenedKeys();
      }
      if (
        v.path.indexOf("/clientManage/") === 0 ||
        v.path.indexOf("/secretKeys/") === 0
      ) {
        this.activeMenu = v.path;
        return;
      }
      const isThirdRoute = v.path.split("/").length > 3;
      const first = v.path.split("/")[1];
      const route = flattenRoute(routes).find((item) => item.path == `/${first}`);
      const hasChildren = !_.isEmpty(route && route.children);
      this.activeMenu = isThirdRoute
        ? this.getOpenedKeys()[2]
        : hasChildren
        ? v.path
        : `/${v.path.split("/")[1]}`;
    },
  },
  methods: {
    menuIconClass(url) {
      const icon = menusIconConfig[url] || "el-icon-menu";
      return icon.indexOf("el-icon") === 0 ? icon : `iconfont icon-${icon}`;
    },
    goHome() {
      if (isNeedChangePassword(this.loginAccountInfo)) {
        if (this.$route.path !== "/personal") {
          this.$router.push("/personal");
        }
        return;
      }
      if (this.$route.path !== "/homePage") {
        this.$router.push("/homePage");
      }
    },
    getUserAuthorizedMenus() {
      if (!this.loginAccountInfo || !this.loginAccountInfo.user_id) return;
      this.$request
        .getUserAuthorizedMenus({
          user_id: this.loginAccountInfo.user_id,
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error((res && res.msg) || "用户未登录");
            return;
          }
          this.$store.commit("setAuthorizedMenus", {
            data: res?.data?.children || [],
            donotJump: true,
          });
        });
    },
    getOpenedKeys() {
      const { path } = this.$route;
      return _.compact(path.split("/")).reduce(
        (rs, item, index) => {
          rs.push(index - 1 >= 0 ? `${rs[index]}/${item}` : `/${item}`);
          return rs;
        },
        ["/"]
      );
    },
    initActiveMenu() {
      this.openedMenus = this.sidebarCollapsed ? [] : this.getOpenedKeys();
      this.activeMenu = this.$route.path;
    },
  },
};
</script>

<style lang="scss">
.aside {
  height: 100%;
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  .aside-logo-content {
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 12px 0 16px;
    overflow: hidden;
    cursor: pointer;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
    box-sizing: border-box;
  }
  .aside-logo-mark {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .logo-img {
    height: 32px;
    width: auto;
    max-width: none;
    display: block;
    object-fit: cover;
    object-position: left center;
  }
  .aside-logo-text {
    margin-left: 10px;
    color: #303133;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
    white-space: nowrap;
    opacity: 1;
    transition: opacity 0.2s;
  }
  &.is-collapse {
    .aside-logo-content {
      padding: 0;
      justify-content: center;
    }
    .aside-logo-text {
      display: none;
    }
  }
  .el-menu-content {
    height: calc(100% - 50px);
    overflow-x: hidden;
    overflow-y: auto;
  }
  .el-menu {
    border: none;
    width: 100%;
  }
  .el-menu--collapse {
    width: 64px;
    .el-menu-item,
    .el-submenu__title {
      padding: 0 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
    .el-tooltip,
    .el-submenu__title,
    .el-menu-item {
      overflow: hidden;
    }
    .el-menu-item > .el-tooltip,
    .el-menu-item {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .el-menu-item i,
    .el-submenu__title i {
      margin: 0 !important;
      width: 24px;
      font-size: 18px;
      display: inline-block;
      text-align: center;
      vertical-align: middle;
    }
    .el-submenu__icon-arrow {
      display: none !important;
    }
    .menu-label,
    .el-submenu__title span,
    .el-menu-item span {
      height: 0;
      width: 0;
      overflow: hidden;
      visibility: hidden;
      display: inline-block;
      padding: 0;
      margin: 0;
    }
  }
  .el-menu-item,
  .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }
  .el-menu-item i,
  .el-submenu__title i {
    color: #606266;
    font-size: 16px;
    margin-right: 8px;
    width: 18px;
    text-align: center;
  }
  .el-submenu.is-active > .el-submenu__title,
  .el-submenu.is-active > .el-submenu__title i {
    color: #409eff;
  }
  .el-menu-item.is-active {
    background-color: rgba(64, 158, 255, 0.1) !important;
    color: #409eff !important;
  }
  .el-menu-item.is-active i {
    color: #409eff;
  }
  .el-submenu .el-menu-item {
    min-width: auto !important;
    background-color: #fff !important;
  }
  .el-submenu .el-menu-item:hover,
  .el-menu-item:hover,
  .el-submenu__title:hover {
    background-color: #f5f7fa !important;
  }
  .el-submenu .el-menu-item.is-active {
    background-color: rgba(64, 158, 255, 0.1) !important;
    color: #409eff !important;
  }
  .el-menu::before {
    display: none;
  }
}

.el-menu--vertical {
  .el-menu-item,
  .el-submenu__title {
    background-color: #fff !important;
    color: #303133 !important;
  }
  .el-menu-item i,
  .el-submenu__title i {
    color: #606266;
  }
  .el-menu-item:hover,
  .el-submenu__title:hover {
    background-color: #f5f7fa !important;
  }
  .el-menu-item.is-active {
    background-color: rgba(64, 158, 255, 0.1) !important;
    color: #409eff !important;
  }
  .el-menu-item.is-active i {
    color: #409eff;
  }
}
</style>
